import React from 'react';
import { useTranslation } from '~/Locale';
import { metaHelper } from '~/helpers/seo';
import useCanonicalUrl from '~/App/shared/hooks/useCanonicalUrl';
import Head from '~/App/shared/components/Head';
import {
  CarBrandAndCategoryData,
  CarTreeFamilyData
} from '~/App/shared/interfaces/store/CmsData';

interface Props {
  cmsData: CarBrandAndCategoryData | CarTreeFamilyData;
}
export const HeadInjection = ({ cmsData }: Props) => {
  const { t } = useTranslation();
  const canonicalUrl = useCanonicalUrl();

  return (
    <Head
      title={cmsData?.seoTitle ?? t('PAGE_META.DEFAULT_OG_TITLE')}
      meta={metaHelper({
        t,
        description: cmsData?.seoDescription,
        seoTitle: cmsData?.seoTitle,
        seoDescription: cmsData?.seoDescription,
        seoImage: cmsData?.seoImageSrc,
        url: canonicalUrl
      })}
      link={[{ rel: 'canonical', href: canonicalUrl }]}
    />
  );
};

export default HeadInjection;
